import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Drawer } from "@mui/material";

import SidebarNav from "./SidebarNav";

const useStyles = makeStyles((theme) => ({
  drawerPerm: {
    width: "100%",
    maxWidth: 200,
    height: "calc(100% - 64px)",
  },
  drawerTemp: {
    width: "100%",
    maxWidth: 200,
    height: "100%",
  },
  root: {
    padding: theme.spacing(1),
  },
  nav: {
    marginBottom: theme.spacing(1),
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();

  return (
    <Drawer
      classes={{
        paper:
          variant === "permanent" ? classes.drawerPerm : classes.drawerTemp,
      }}
      onClose={onClose}
      open={open}
      variant={variant}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <SidebarNav className={classes.nav} onClose={onClose} />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
